import Vue from 'vue'
import Router from 'vue-router'
// import Threed from '@/components/threed/threed'
const index = resolve => require(['@/views/zfw/index.vue'], resolve)

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: 'xry',
  routes: [
	   // { path: '/',component: Threed},
      {
          path: '/index',
          name: 'index',
          component: index
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js